var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnbd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 761.71 180.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fdb811;\n      }\n\n      .cls-3 {\n        fill: #001e5e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path19061",
    className: "cls-3",
    d: "m761.71,180.4H134.45V.31h627.26v180.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19063",
    className: "cls-1",
    d: "m302.39,73.81h13.11v50.35h-13.11v-50.35Zm0-21.69h13.11v12.5h-13.11v-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19065",
    className: "cls-1",
    d: "m173.65,55.66h40.27v10.75h-26.58v16.8h24.32v10.75h-24.32v19.16h26.76v10.75h-40.45V55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19067",
    className: "cls-1",
    d: "m220.85,73.53h12.22v7.06h.22c4.09-6.17,10.05-8.22,14.94-8.22,7.06,0,12.04,2.63,14.88,8.89,3.02-6.05,9.56-8.89,15.73-8.89,12.4,0,15.92,8.52,15.92,19.74v31.77h-13.11v-30c0-4.7,0-11.33-7.52-11.33-8.71,0-9.78,10.36-9.78,16.89v24.44h-13.11v-30c0-4.7,0-11.33-7.52-11.33-8.71,0-9.78,10.36-9.78,16.89v24.44h-13.11v-50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19069",
    className: "cls-1",
    d: "m322.7,73.53h11.64v11.46h.18c.61-4.7,5.99-12.62,13.81-12.62,1.25,0,2.63,0,4,.4v13.2c-1.19-.7-3.51-1.07-5.87-1.07-10.66,0-10.66,13.29-10.66,20.5v18.48h-13.11v-50.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19071",
    className: "cls-1",
    d: "m372.62,115.48c4,0,7.15-1.74,9.2-4.49,2.14-2.84,2.72-6.45,2.72-10.39h-5.65c-5.87,0-14.57.98-14.57,8.74,0,4.28,3.64,6.14,8.31,6.14m-15.34-39.29c5.07-2.35,11.91-3.82,17.47-3.82,15.37,0,21.72,6.35,21.72,21.2v6.45c0,5.1.09,8.92.18,12.62.09,3.82.31,7.33.58,11.24h-11.52c-.49-2.63-.49-5.96-.58-7.52h-.22c-3.02,5.56-9.59,8.71-15.55,8.71-8.89,0-17.6-5.38-17.6-14.97,0-7.52,3.64-11.91,8.61-14.36,4.98-2.44,11.43-2.93,16.93-2.93h7.21c0-8.13-3.6-10.88-11.33-10.88-5.56,0-11.15,2.17-15.55,5.5l-.35-11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19073",
    className: "cls-1",
    d: "m406.84,83.13h-9.68v-9.59h9.68v-10.05l13.11-4.22v14.27h11.64v9.59h-11.64v23.46c0,4.28,1.16,8.31,6.14,8.31,2.35,0,4.61-.49,5.96-1.37l.4,10.36c-2.75.79-5.74,1.19-9.65,1.19-10.26,0-15.95-6.39-15.95-16.34v-25.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19075",
    className: "cls-1",
    d: "m467.24,93.79c-.37-6.35-3.3-11.82-10.63-11.82s-11.06,5.07-11.64,11.82h22.27Zm8.8,27.25c-4.8,2.66-10.23,4.03-17.29,4.03-16.62,0-26.3-9.59-26.3-26.12,0-14.54,7.73-26.58,23.37-26.58,18.67,0,23.95,12.8,23.95,30.4h-34.8c.58,8.1,6.26,12.71,14.36,12.71,6.35,0,11.82-2.35,16.71-5.07v10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19077",
    className: "cls-1",
    d: "m515.05,84.11c-4-1.37-6.93-2.14-11.73-2.14-3.51,0-7.7,1.25-7.7,5.56,0,8,22.76,2.93,22.76,21.11,0,11.73-10.48,16.44-21.11,16.44-5.01,0-10.08-.89-14.88-2.17l.79-10.75c4.12,2.05,8.4,3.33,12.89,3.33,3.33,0,8.62-1.28,8.62-6.14,0-9.9-22.79-3.15-22.79-21.32,0-10.85,9.5-15.64,19.77-15.64,6.14,0,10.17.98,14.27,1.86l-.89,9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19079",
    className: "cls-1",
    d: "m545.02,55.66h16.8l26,51.02h.22v-51.02h13.08v68.22h-16.71l-26.09-51.02h-.22v51.02h-13.08V55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19081",
    className: "cls-1",
    d: "m625.52,113.13h6.45c6.35,0,14.08-1.56,14.08-9.47,0-8.89-7.24-10.26-14.08-10.26h-6.45v19.74Zm0-29.91h5.56c5.77,0,12.89-1.25,12.89-8.31,0-7.91-6.93-8.49-13.17-8.49h-5.29v16.8Zm-13.69-27.56h23.83c8.8,0,22,2.54,22,17.51,0,8.1-5.44,13.78-13.56,15.24v.18c9.29.89,15.64,7.15,15.64,15.55,0,17.2-15.46,19.74-24.07,19.74h-23.83V55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19083",
    className: "cls-1",
    d: "m680.88,113.13h7.64c11.43,0,22.49-8.49,22.49-23.34s-11.06-23.37-22.49-23.37h-7.64v46.71Zm-13.69-57.47h18.7c20.9,0,39.38,7.06,39.38,34.12s-18.48,34.09-39.38,34.09h-18.7V55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19085",
    className: "cls-3",
    d: "m122.29,180.12H0V.03h122.29v180.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19087",
    className: "cls-1",
    d: "m50.38,109.65c1.62-44.57,25.66-84.01,61.77-109.65h-23.98c-29.27,25.42-48.91,61.1-49.74,100.76-.64,31.44,5.41,55.33,22.09,79.43h6.11c-13.04-22.18-17.17-45.46-16.25-70.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19089",
    className: "cls-2",
    d: "m54.35,180.16c-14.45-15.34-31.89-44.21-33.94-75.4C17.9,66.6,30.52,29.45,55.97.03h19.71c-31.13,30.89-46.93,71.79-43.32,112.46,2.32,25.97,12.53,45.18,28.2,67.67h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19091",
    className: "cls-1",
    d: "m61.01,142.58c13.14-13.6,25.39-33.24,29.24-52.85,5.41-27.46-1.71-50.16-2.17-51.72-.34-1.13-.52-1.86-.34-1.96.37-.22,3.15,4.74,5.04,8.65,3.64,7.58,7.55,19.83,7.36,33.91-.27,17.47-6.51,34.86-17.81,48.27-3.91,4.64-8.4,8.77-13.47,12.22-3.3,2.23-8.98,5.32-9.17,5.01-.13-.18.52-.7,1.31-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19093",
    className: "cls-2",
    d: "m60.55,142.98c8.83-10.17,16.77-24.56,18.7-38.55,2.72-19.64-3.3-35.38-3.7-36.48-.31-.76-.46-1.28-.34-1.34.27-.18,2.47,3.21,3.97,5.9,2.9,5.19,6.23,13.69,6.66,23.65.52,12.34-3.18,24.9-10.69,34.83-2.63,3.45-5.65,6.57-9.13,9.23-2.26,1.71-6.17,4.12-6.32,3.91-.13-.16.34-.52.86-1.13"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnbd);
export default __webpack_public_path__ + "static/media/enbd.91f92da2dff3bc0b796297d72f1666c8.svg";
export { ForwardRef as ReactComponent };